<template>
  <f7-page name="marketplace-dashboard" @page:init="onPageInit">
    <f7-navbar :title="$t('marketplaceDashboard.title')" no-shadow>
      <f7-nav-right>
        <f7-link icon-f7="list" href="/dashboard/admin" :text="$t('adminDashboard.title')" />
      </f7-nav-right>
    </f7-navbar>
    <AppLayout>
      <template #main>

        <f7-block v-if="loadError" class="dash-error">
          <f7-icon f7="exclamationmark_triangle_fill" />
          <span>{{ loadError }}</span>
          <f7-button small fill @click="load">{{ $t('common.retry') }}</f7-button>
        </f7-block>

        <SkeletonList v-if="loading && !data" variant="card" :rows="3" />

        <div v-else-if="data">
          <MarketplaceMetricGrid :data="data" />
          <MarketplaceOrdersSection :data="data" />
          <MarketplaceGbSection :data="data" />
          <MarketplaceStbSection :data="data" />

          <f7-link class="text-align-center display-block" href="/dashboard/admin">
            <small>{{ $t('adminDashboard.title') }} →</small>
          </f7-link>

          <f7-block strong inset class="text-align-center">
            <small class="text-color-gray">{{ lastUpdate }}</small>
          </f7-block>
          </div>
        </template>

    </AppLayout>
  </f7-page>
</template>

<style scoped>
.dash-error {
  display: flex;
  align-items: center;
  gap: 10px;
  background: color-mix(in srgb, var(--f7-theme-color) 10%, transparent);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--f7-theme-color);
  font-size: 13px;
}
</style>

<script setup>
import { ref, computed, onMounted } from 'vue';
import AppLayout from '../components/common/AppLayout.vue';
import SkeletonList from '../components/common/SkeletonList.vue';
import { useDashboardMetrics } from '../js/composables/useDashboardMetrics.js';

import MarketplaceMetricGrid from '../components/dashboard/MarketplaceMetricGrid.vue';
import MarketplaceOrdersSection from '../components/dashboard/MarketplaceOrdersSection.vue';
import MarketplaceGbSection from '../components/dashboard/MarketplaceGbSection.vue';
import MarketplaceStbSection from '../components/dashboard/MarketplaceStbSection.vue';

import i18n from '../js/i18n.js';
const { t } = i18n.global;

const {
  marketplaceMetrics: data,
  marketplaceLoading: loading,
  marketplaceError,
  fetchMarketplaceCurrent,
} = useDashboardMetrics();

const loadError = ref(null);

const lastUpdate = computed(() =>
  data.value?.metricDate
    ? t('marketplaceDashboard.lastUpdated') + ' ' + data.value.metricDate
    : '',
);

async function load() {
  loadError.value = null;
  try {
    await fetchMarketplaceCurrent();
  } catch (err) {
    loadError.value = err?.response?.data?.message || err?.message || t('marketplaceDashboard.noData');
  }
}

function onPageInit() {
  load();
}

onMounted(() => {
  load();
});
</script>